module.exports = __webpack_public_path__ + "img/immagine_pellegrini.f8fab0d6.jpg";